var _circle, _g, _circle2, _circle3, _ellipse, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeInternationalWireOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#DFE2EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8988_24229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1486 42.0302C31.1281 55.4952 41.1048 59.0917 46.1393 58.5473L40.791 47.1977L25.1486 42.0302Z",
    fill: "#DFE2EB",
    stroke: "#00193C",
    strokeWidth: 1.13725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7185 49.3777C36.4792 58.0079 44.8913 59.2424 49.4874 58.2768C56.2641 57.3933 64.1604 50.6227 69.9265 44.4155C71.8311 42.3653 73.5032 40.3765 74.8259 38.6816C75.34 38.0228 74.9675 37.0612 74.1565 36.8596C72.286 36.3948 70.4633 35.7814 68.7263 35.0834C64.8992 33.5456 61.4883 31.5974 58.8997 29.9245C57.068 28.7407 55.6481 27.6947 54.7839 27.0295C54.2633 26.6288 53.5062 26.7241 53.1017 27.2418C51.9781 28.6801 50.5689 30.3008 48.9122 31.9155C44.6108 36.108 38.6406 40.26 31.6664 41.0734C29.9988 41.2679 28.274 41.2716 26.5007 41.0392C25.4235 40.8981 24.7423 42.0308 25.6168 42.6754C26.8119 43.5564 28.2116 44.3134 29.6916 44.9613C29.7012 44.9658 29.711 44.9701 29.7208 44.9741C32.7881 46.313 36.1963 47.1842 38.842 47.719C39.5782 47.8678 39.9825 48.6745 39.7185 49.3777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7263 35.0834C70.4633 35.7814 72.286 36.3948 74.1565 36.8596C74.9675 37.0612 75.34 38.0228 74.8259 38.6816C73.5032 40.3765 71.8311 42.3653 69.9265 44.4155M68.7263 35.0834C66.5446 36.984 63.7302 41.5112 69.9265 44.4155M68.7263 35.0834C64.8992 33.5456 61.4883 31.5974 58.8997 29.9245M69.9265 44.4155C64.1604 50.6227 56.2641 57.3933 49.4874 58.2768C44.8913 59.2424 36.4792 58.0079 39.7185 49.3777C39.9825 48.6745 39.5782 47.8678 38.842 47.719C36.1879 47.1825 32.7665 46.3074 29.6916 44.9613M58.8997 29.9245C57.068 28.7407 55.6481 27.6947 54.7839 27.0295C54.2633 26.6288 53.5062 26.7241 53.1017 27.2418C51.9781 28.6801 50.5689 30.3008 48.9122 31.9155M58.8997 29.9245C57.3569 32.5723 53.1993 36.6773 48.9122 31.9155M48.9122 31.9155C44.6108 36.108 38.6406 40.26 31.6664 41.0734M31.6664 41.0734C29.9988 41.2679 28.274 41.2716 26.5007 41.0392C25.4235 40.8981 24.7423 42.0308 25.6168 42.6754C26.8119 43.5564 28.2116 44.3134 29.6916 44.9613M31.6664 41.0734C33.6411 42.6717 30.8642 45.5072 29.6916 44.9613",
    stroke: "#00193C",
    strokeWidth: 1.13725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6185 40.717C43.1232 43.1016 42.8943 46.7733 44.9446 48.9187C46.9949 51.0641 50.6732 51.0019 53.1684 48.6173C55.6637 46.2328 55.8926 42.5611 53.8423 40.4156C51.792 38.2702 48.1137 38.3324 45.6185 40.717Z",
    fill: "white",
    stroke: "#20242E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1402 46.0854C51.823 45.4026 51.958 44.4307 51.4419 43.9145C50.9257 43.3984 50.0952 43.392 49.271 44.2162C48.4468 45.0404 47.6163 45.034 47.1001 44.5179C46.584 44.0017 46.719 43.0298 47.4018 42.347M51.1402 46.0854C50.6826 46.543 50.0951 46.7545 49.602 46.689M51.1402 46.0854L51.6075 46.5527M47.4018 42.347L46.9345 41.8797M47.4018 42.347C47.8594 41.8894 48.4469 41.6778 48.94 41.7434",
    stroke: "#0E5CF4",
    strokeWidth: 1.13725,
    strokeLinecap: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 14.5,
    fill: "#0E5CF4",
    stroke: "#20242E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 9,
    fill: "white",
    stroke: "#13151A",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 61,
    rx: 4.5,
    ry: 9,
    fill: "white",
    stroke: "#13151A",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 61H70",
    stroke: "#13151A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8988_24229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 54,
    fill: "white",
    transform: "translate(24 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeInternationalWireOut);
export default __webpack_public_path__ + "static/media/ic-large-international_wire_out.76ad36bcadc33790d0ad6552f8c3b820.svg";
export { ForwardRef as ReactComponent };